let originalFaviconUrl = null;

function replaceFavicon(href) {
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = href;

  document.querySelectorAll("link[rel='icon']").forEach((el) => el.remove());
  document.head.appendChild(link);
}

export const updateFaviconBadge = (
  hasNotification,
  originalUrl = '/favicon-32x32.png'
) => {
  const faviconEl = document.querySelector("link[rel='icon']");
  if (!faviconEl) return;

  if (!originalFaviconUrl || originalUrl) {
    originalFaviconUrl = originalUrl;
  }

  if (!hasNotification) {
    replaceFavicon(originalFaviconUrl);
    return;
  }

  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.src = originalFaviconUrl;

  img.onload = () => {
    const size = 32;
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, size, size);

    ctx.fillStyle = '#FF382D';
    ctx.beginPath();
    ctx.arc(size - 6, 6, 5, 0, Math.PI * 2);
    ctx.fill();

    const newFaviconUrl = canvas.toDataURL('image/png');
    replaceFavicon(newFaviconUrl);
  };

  img.onerror = () => {
    console.warn(
      '⚠️ Failed to load favicon. Possibly a CORS issue or incorrect path:',
      originalFaviconUrl
    );
  };
};
